export const FEATURE_NAMESPACE = 'feature.pom'
